import React from 'react';
import '../styles/CampaignTerms.css';  // CSSファイルを別途作成
import { startDate, endDate } from './discountPeriod';  // 期間データをインポート

const CampaignTerms = () => {
  // 現在の日時を取得
  const now = new Date();

  // 日付を "YYYY年MM月DD日" 形式にフォーマットする関数
  const formatDate = (date) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formattedDate = date.toLocaleDateString('ja-JP', options);
    
    // フォーマット後に「年」「月」「日」を追加
    const [year, month, day] = formattedDate.split('/');
    return `${year}年${month}月${day}日`;
  };

  // endDateの1日前の日付を計算
  const adjustedEndDate = new Date(endDate);
  adjustedEndDate.setDate(endDate.getDate() - 1);  // 1日前に調整

  // 現在の日時が指定された範囲内の場合にのみ表示
  if (now >= startDate && now < endDate) {
    return (
      <div className="campaign-terms">
        <div className="title">キャンペーン適用条件</div>
        <ul>
          <li>{formatDate(startDate)} ~ {formatDate(adjustedEndDate)} の間に体験レッスンをお申し込み</li>
          <li>体験レッスンご受講後24時間に入会お申し込み</li>
          <li>割引プランの併用は不可となります</li>
          <li>入会後90日以内に退会または休会された場合は割引分を追加決済させていただきます</li>
        </ul>
      </div>
    );
  } else {
    // 期間外の場合は何も表示しない
    return null;
  }
};

export default CampaignTerms;

